export default "__VITE_ASSET__31d4a1bc__"